/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
export {BrowserAnimationBuilder as ÉµBrowserAnimationBuilder} from './animation_builder';
export {RuntimeErrorCode as ÉµRuntimeErrorCode} from './errors';
export {AnimationGroupPlayer as ÉµAnimationGroupPlayer} from './players/animation_group_player';

export const ÉµPRE_STYLE = '!';
